import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index" }

import { computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useCinemaStore } from '@remote/store/cinema'
import Collection from '@remote/components/cinema/CinemaCollection.vue'
import CinemaEmpty from '@remote/components/cinema/CinemaEmpty.vue'
import { stat } from '@remote/utils/stat'


export default /*#__PURE__*/_defineComponent({
  props: {
  isShowing: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const cinemaStore = useCinemaStore()

const indexRecentCollection = computed(() => {
  return cinemaStore.recentList.slice(0, 30)
})

const indexMovieCollection = computed(() => {
  return cinemaStore.movieList.slice(0, 30)
})

const indexTVCollection = computed(() => {
  return cinemaStore.tvList.slice(0, 30)
})

const isAllCollectionEmpty = computed(() => {
  return indexMovieCollection.value.length === 0 && indexTVCollection.value.length === 0
})

watch(() => props.isShowing, () => {
  if (props.isShowing) {
    stat({
      action: 'cinema_channel_show',
      data: {
        if_content_blank: isAllCollectionEmpty.value ? 1 : 0,
        page: 'main_page',
        status: cinemaStore.isScraping ? 1 : 0,
      },
    })
  }
})

function onPageFocus () {
  if (document.hidden) return
  if (cinemaStore.isPlaying) {
    const isWebPlaying = !!document.querySelector('.dplayer')
    if (!isWebPlaying) {
      cinemaStore.refreshRecentNFOList()
    }
    cinemaStore.setPlaying(false)
  }
}

onMounted(() => {
  document.addEventListener('visibilitychange', onPageFocus)
  document.addEventListener('refreshRecentNFOList', cinemaStore.refreshRecentNFOList)
})

onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', onPageFocus)
  document.removeEventListener('refreshRecentNFOList', cinemaStore.refreshRecentNFOList)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isAllCollectionEmpty))
      ? (_openBlock(), _createBlock(CinemaEmpty, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(Collection, {
            key: "recent_watch_media",
            type: "recent_watch",
            title: "最近观看",
            nfos: _unref(indexRecentCollection)
          }, null, 8, ["nfos"]),
          _createVNode(Collection, {
            key: "recent_add_movie",
            type: "recent_add",
            title: "最近添加的电影",
            nfos: _unref(indexMovieCollection)
          }, null, 8, ["nfos"]),
          _createVNode(Collection, {
            key: "recent_add_tv",
            type: "recent_add",
            title: "最近添加的电视剧",
            nfos: _unref(indexTVCollection)
          }, null, 8, ["nfos"])
        ], 64))
  ]))
}
}

})